<template>
  <div class="server">
    <div ref="TOP" style="padding-top: 4.3rem"></div>
    <img src="@/assets/server/top.png" alt="">
    <div class="module">
      <div class="item">
        <div class="img"><img src="@/assets/server/1-1.png" alt=""></div>
        <div class="name">社区基础准备</div>
        <div class="subtitle">Community foundation preparation</div>
        <div class="i"><div class="r"></div>业主委员会成员上线</div>
        <div class="i"><div class="r"></div>基础数据云管理</div>
        <div class="i"><div class="r"></div>收缴费云管理</div>
      </div>
      <div class="item">
        <div class="img"><img src="@/assets/server/1-2.png" alt=""></div>
        <div class="name">社区线上运营</div>
        <div class="subtitle">Community online operation</div>
        <div class="i"><div class="r"></div>报修线上管理</div>
        <div class="i"><div class="r"></div>巡检线上管理</div>
        <div class="i"><div class="r"></div>巡检线上管理</div>
      </div>
      <div class="item">
        <div class="img"><img src="@/assets/server/1-3.png" alt=""></div>
        <div class="name">社区自运营</div>
        <div class="subtitle">Community self operation</div>
        <div class="i"><div class="r"></div>在线投票决策</div>
        <div class="i"><div class="r"></div>在线财务公示</div>
        <div class="i"><div class="r"></div>在线监督管理</div>
      </div>
    </div>
    <div ref="EP"></div>
    <div class="">
      <div class="title">
        <div class="top">入场准备</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Entry preparation</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="preparation">
        <div class="item" :class="{selected: preparation === 0}" @click="preparation = 0"><div class="img"><img src="@/assets/server/2-1.png" alt="" v-if="preparation === 0"><img src="@/assets/server/2-1-1.png" alt="" v-else></div>人员</div>
        <div class="item" :class="{selected: preparation === 1}" @click="preparation = 1"><div class="img"><img src="@/assets/server/2-2.png" alt="" v-if="preparation === 1"><img src="@/assets/server/2-2-1.png" alt="" v-else></div>数据</div>
        <div class="item" :class="{selected: preparation === 2}" @click="preparation = 2"><div class="img"><img src="@/assets/server/2-3.png" alt="" v-if="preparation === 2"><img src="@/assets/server/2-3-1.png" alt="" v-else></div>财务</div>
        <div class="item" :class="{selected: preparation === 3}" @click="preparation = 3"><div class="img"><img src="@/assets/server/2-4.png" alt="" v-if="preparation === 3"><img src="@/assets/server/2-4-1.png" alt="" v-else></div>服务</div>
        <div class="item" :class="{selected: preparation === 4}" @click="preparation = 4"><div class="img"><img src="@/assets/server/2-5.png" alt="" v-if="preparation === 4"><img src="@/assets/server/2-5-1.png" alt="" v-else></div>资产</div>
        <div class="item" :class="{selected: preparation === 5}" @click="preparation = 5"><div class="img"><img src="@/assets/server/2-6.png" alt="" v-if="preparation === 5"><img src="@/assets/server/2-6-1.png" alt="" v-else></div>宣导</div>
      </div>
      <div class="preparation-text">
          {{preparations[preparation]}}
        </div>
    </div>
    <div ref="PA"></div>
    <div class="">
      <div class="title">
        <div class="top">平台优势</div>
        <div class="bottom">
          <div class="line"></div>
          <div class="text">Platform advantages</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="advantages">
        <div class="change-bar">
          <span :class="{selected: advantages === 0}" @click="selectAdvantages(0)">物业管理</span><span class="selected mid">/</span><span :class="{selected: advantages === 1}" @click="selectAdvantages(1)">业主自治</span>
        </div>
        <div class="item animate__animated animate__fadeIn" v-show="advantages === 0">
          <div class="i">
            <div ref="0" class="img wow animate__fadeInLeft animation-delay-300ms"><img src="@/assets/server/3-1.png" alt=""></div>
            <div class="main">
              <div class="i-title">
                <div class="name">收费标准不明确，委托收费，擅自加价</div>
                <div class="subtitle">Estate Management</div>
              </div>
              <div class="text">
                通过平台及智能终端的使用，将物业员工的日常工作行为，由传统方式转变为信息化方式，建立信息化管理流程，将所有项目的收费明细信息全程记录在系统中，随时查询追溯，规避偷拿卡扣现象，同时在系统中，对物业管理过程中的所有收费项目设立收费标准，杜绝乱收费现象。
              </div>
            </div>
          </div>
          <div class="i">
            <div class="main">
              <div class="i-title">
                <div class="name">齐抓共管工作格局尚未形成，问题投诉层出不穷</div>
                <div class="subtitle">Estate Management</div>
              </div>
              <div class="text">
                使用爱多路平台管理下的小区，爱多路会完善小区设备台账和业主信息，并且对小区的人行，车行的动线进行改造，减少小区出行乱象。在配备人脸识别门禁，车牌识别道闸，二轮充电桩的智能设备，规范小区的人行，车行。并且可以控制异常来访和可疑人员的轨迹分析。
              </div>
            </div>
            <div ref="1" class="img wow animate__fadeInRight animation-delay-300ms"><img src="@/assets/server/3-2.png" alt=""></div>
          </div>
          <div class="i">
            <div ref="2" class="img wow animate__fadeInLeft animation-delay-300ms"><img src="@/assets/server/3-3.png" alt=""></div>
            <div class="main">
              <div class="i-title">
                <div class="name">前期物业服务质量未达标，问题投诉层出不穷</div>
                <div class="subtitle">Estate Management</div>
              </div>
              <div class="text">
                通过爱多路平台及智能社区硬件的引入，以技术替代人力，替代物业管理工作中重复繁琐工作，减少物业服务对人员的需求，同时依托系统，在科技赋能实现的统筹管理下，以科学角度制订工作标准、工作内容、评价反馈机制，提高物业工作效率，发挥出最大效用。
              </div>
            </div>
          </div>
        </div>
        <div class="item animate__animated animate__fadeIn" v-show="advantages === 1">
          <div class="i">
            <div class="main">
              <div class="i-title">
                <div class="name">业主自我管理意识薄弱，小区自治难形成</div>
                <div class="subtitle">Owner Autonomy</div>
              </div>
              <div class="text">
                居务公开、小区公告、在线服务、自治议事、邻里互动等功能的实现为小区业主和物业服务人员建立了一个有效沟通的渠道，也为小区开辟了一条信息瞬间传递的通道，通过对业主信息、留言的回复，加深了小区服务人员与业主的联系，决策权的下放也调动起了业主参与小区事务的热情，充分实现了业主从“小区事务观察者”到“小区事务参与者”再到“小区事务引领者”的角色转变。
              </div>
            </div>
            <div ref="3" class="img wow animate__fadeInRight animation-delay-300ms"><img src="@/assets/server/3-4.png" style="" alt=""></div>
          </div>
          <div class="i">
            <div ref="4" class="img wow animate__fadeInLeft animation-delay-300ms"><img src="@/assets/server/3-5.png" alt=""></div>
            <div class="main">
              <div class="i-title">
                <div class="name">小区自治难形成，业主自治能力缺乏</div>
                <div class="subtitle">Owner Autonomy</div>
              </div>
              <div class="text">
                业主可通过小程序及APP定期获取涉及业主切身利益的宣传政策、小区建设情况、小区问题解决跟进情况，业主可通过门禁控制、家居报警控制系统、信息发布系统、数据可视化系统等形式数据化管理小区。
              </div>
            </div>
          </div>
          <div class="i">
            <div class="main">
              <div class="i-title">
                <div class="name">社区资产盘点艰难，无有效的管理手段</div>
                <div class="subtitle">Owner Autonomy</div>
              </div>
              <div class="text">
                有效运用5G、物联网、大数据、人工智能、区块链等新一代信息技术，充分融合人、地、物、情、事、组织等多方因素的老旧小区业主自治管理平台，实现了基础设施智能化、公共服务便捷化、小区治理精准化，提高了小区管理与服务的科学化、智能化、精细化水平，为小区推进数字治理、精准管理、精细服务提供了可能。
              </div>
            </div>
            <div ref="5" class="img wow animate__fadeInRight animation-delay-300ms"><img src="@/assets/server/3-6.png" style="" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
export default {
  name: 'Server',
  data () {
    return {
      preparation: 0,
      preparations: [
        '业主委员会成员上线，引导业主注册并使用爱多路平台',
        '社区资产盘点，包括房产，车位，设施设备等数据入库形成完整的数据台账',
        '对小区收费项目和支出项目进行盘点，并且入库形成完善的财务报告',
        '对小区已有的服务进行整合，将服务规范录入系统，并由系统自动派发任务',
        '对公共收益部分进行盘点入库',
        '党建引领'
      ],
      advantages: 0
    }
  },
  computed: {
    routeSelected () {
      return this.$route.query.selected
    }
  },
  watch: {
    routeSelected (val) {
      const t = this
      setTimeout(() => {
        t.$refs[val].scrollIntoView({
          behavior: 'smooth'
        })
      }, 100)
    }
  },
  mounted () {
    const t = this
    if (t.$route.query.selected !== undefined) {
      setTimeout(() => {
        t.$refs[this.$route.query.selected].scrollIntoView({
          behavior: 'smooth'
        })
      }, 100)
    }
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animate__animated',
      offset: 0,
      mobile: true
    })
    wow.init()
  },
  methods: {
    selectAdvantages (e) {
      this.advantages = e
      var wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animate__animated',
        offset: 0,
        mobile: true
      })
      wow.init()
    }
  }
}
</script>
<style scoped>
.server {

}
.module {
  height: 38rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  padding-bottom: 3rem;
  box-sizing: border-box;
  max-width: 150rem;
  margin: 0 auto;
}
.module .item {
  height: 45rem;
  width: 35rem;
  border-radius: 1rem;
  box-shadow:0px 0px 2rem 0px rgba(171, 180, 200, 0.3);
  background-size: 100% 100%;
  background-color: #FFFFFF;
  padding: 4rem;
  box-sizing: border-box;
  text-align: left;
  font-weight: bolder;
}
.module .item .img {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 2rem;
}
.module .item .img img {
  width: 14.5rem;
}
.module .item .name {
  color: #000000;
  font-size: 2.4rem;
}
.module .item .subtitle {
  color: #E7E6E6;
  font-size: 1.3rem;
  text-transform: uppercase;
  padding-bottom: 1rem;
}
.module .item .i {
  display: flex;
  align-items: center;
  color: #434343;
  font-size: 1.4rem;
  padding-top: 2rem;
}
.module .item .i .r {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background-color: #FF8C33;
  margin-right: 1rem;
}
.title {
  padding: 7.5rem 0;
  background-color: #FFFFFF;
}
.title .top {
  font-size: 2.6rem;
  line-height: 5.4rem;
  font-weight: bolder;
  color: #FF8C33;
}
.title .bottom {
  display: flex;
  align-items: center;
  justify-content: center;
}
.title .line {
  width: 30rem;
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #CECECE;
}
.title .text {
  font-size: 2.6rem;
  font-weight: bolder;
  color: #E7E6E6;
  margin: 0 2rem;
  text-transform: uppercase;
}
.title .text span {
  text-transform: lowercase;
}
.preparation {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  max-width: 150rem;
  margin: 0 auto;
}
.preparation .item {
  width: 9rem;
  font-size: 1.4rem;
  color: #000000;
  padding: 5rem 0.5rem 14rem 0.5rem;
  box-sizing: border-box;
  transition: all 0.2s;
}
.preparation .item .img {
  height: 15rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preparation .item.selected {
  color: #FF8C33;
  width: 9rem;
  padding: 5rem 0rem 14rem 0rem;
  font-weight: bolder;
}
.preparation-text {
  width: 100%;
  background-color: #F9F9F9;
  color: #666666;
  padding: 4.5rem;
  font-size: 1.4rem;
  box-sizing: border-box;
}
.advantages {
  padding-bottom: 12rem;
  max-width: 120rem;
  margin: 0 auto;
}
.advantages .change-bar {
  display: flex;
  align-items: center;
  font-size: 2rem;
}
.advantages .change-bar .mid {
  padding: 0 1rem;
}
.advantages .change-bar .selected {
  color: #FF8C33;
  font-size: 2.8rem;
  font-weight: bolder;
}
.advantages .item .i {
  display: flex;
  align-items: center;
  text-align: left;
  font-weight: bolder;
  padding-top: 12rem;
}
.advantages .item .i .img {
  width: 50%;
  min-width: 50%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.advantages .item .i .img img {
  object-fit: contain;
}
.advantages .item .i .main {
  padding:  0 2.5rem;
}
.advantages .item .i .i-title {
  border-left: 0.4rem solid #FF8C33;
  padding-left: 3rem;
}
.advantages .item .i .i-title .name {
  color: #000000;
  font-size: 2.8rem;
}
.advantages .item .i .i-title .subtitle {
  color: #E7E6E6;
  font-size: 1.6rem;
  text-transform: uppercase;
}
.advantages .item .i .text {
  font-size: 1.4rem;
  color: #434343;
  line-height: 3.6rem;
  padding: 3rem 0 3rem 3.4rem;
  font-weight: normal;
}
</style>
